export default class RelatorioConta {
    constructor(rela_nome, rela_dtRegConta, rela_email, rela_plano, rela_fat_razao, rela_fat_cnpj, rela_totalEmp, rela_totalColab, arrayEmpresas, _id) {
        // notas[i].master.nome,
        // notas[i].dtRegIn,
        // notas[i].master.email,
        // notas[i].rela_plano,
        // notas[i].faturamento.rela_fat_razao,
        // notas[i].faturamento.cnpj,
        // notas[i].empresas.length,
        // totalColab,
        // notas[i].total_nfe,
        // notas[i].total_nfse,
        // notas[i].total_cte,
        // notas[i].arrayEmpresas,
        // notas[i]._id

        this.rela_nome = rela_nome;
        this.rela_dtRegConta = new Date(rela_dtRegConta);
        this.rela_email = rela_email;
        this.rela_plano = rela_plano;
        this.rela_fat_razao = rela_fat_razao;
        this.rela_fat_cnpj = rela_fat_cnpj;
        this.rela_totalEmp = rela_totalEmp;
        this.rela_totalColab = rela_totalColab;
        // this.rela_totalNfe = rela_totalNfe;
        // this.rela_totalNfse = rela_totalNfse;
        // this.rela_totalCte = rela_totalCte;
        this.arrayEmpresas = arrayEmpresas;
        this._id = _id;
    }
}


// WEBPACK FOOTER //
// ./src/domain/conta/RelatorioConta.js